import React from "react";
import { useSelector } from "react-redux";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Notification from "pages/_components/Notification";
import GeneralCredentialForm from "pages/_components/Forms/GeneralCredentialForm";
import I18n from "pages/_components/I18n";
import { actions as echeckActions } from "reducers/echecks";
import { useConfirmTransaction } from "hooks/useConfirmTransaction";
import SolicitAvalSummaryBody from "./components/Summary";

const ActionsAvalSummaryPage = () => {
    const { echeqsToDoActions, echeckTicket } = useSelector((state) => state.echecks);
    let title;
    let activity;
    if (echeqsToDoActions?.action === "AVAL-ANULATE") {
        title = "echeq.anulate.aval.echeq";
        activity = "echeq.aval-anulate.action";
    }
    if (echeqsToDoActions?.action === "AVAL-REPUDIATE") {
        title = "echeq.repudiate.aval.echeq";
        activity = "echeq.aval-repudiate.action";
    }
    if (echeqsToDoActions?.action === "AVAL-ADMIT") {
        title = "echeq.accept.aval.echeq";
        activity = "echeq.aval-admit.action";
    }

    const motiveSelect = () => {
        let motive;
        if (echeqsToDoActions?.action === "AVAL-ADMIT") {
            motive = echeqsToDoActions?.echeq?.cheque_motivo_pago;
        } else {
            motive = echeqsToDoActions?.specialAttribute;
        }
        return motive;
    };
    const documentType = echeqsToDoActions?.echeq?.avalistas[0]?.aval_documento_tipo;
    const documentNumber = echeqsToDoActions?.echeq?.avalistas[0]?.aval_documento;
    const data = {
        numeroEcheq: echeqsToDoActions?.echeq?.cheque_numero,
        montoTotal: echeqsToDoActions?.echeq?.monto,
        curency: echeqsToDoActions?.echeq?.emisor_moneda,
        idEcheq: echeqsToDoActions?.echeq?.cheque_id,
        document: `${documentType} ${documentNumber}`,
        avalista: echeqsToDoActions?.echeq?.avalistas[0]?.aval_razon_social,
        domicilio: echeqsToDoActions?.echeq?.avalistas[0]?.aval_domicilio,
        caracterAval: echeqsToDoActions?.echeq?.avalistas[0]?.aval_caracter,
        fechaEmision: echeqsToDoActions?.echeq?.fecha_emision,
        fechaPago: echeqsToDoActions?.echeq?.fecha_pago,
        concepto: echeqsToDoActions?.echeq?.cheque_concepto,
        motivoAnulacion: motiveSelect(),
        action: echeqsToDoActions?.action,
        specialAttribute: echeqsToDoActions?.specialAttribute,
        echeqList: [echeqsToDoActions?.echeq],
        echeqsToDoActions,
        idTransaction: echeqsToDoActions?.idTransaction,
    };
    useConfirmTransaction(data, echeckTicket, "echecks/aval/update");
    return (
        <>
            <Notification scopeToShow="echecks/aval/confirm" />
            <ResponsiveHeader id={title} />
            <MainContainer>
                <div className="container">
                    <h2>
                        <I18n id="echecks.summary.confirm.aval" />
                    </h2>
                    <SolicitAvalSummaryBody
                        numeroEcheq={echeqsToDoActions?.echeq?.cheque_numero}
                        montoTotal={echeqsToDoActions?.echeq?.monto}
                        curency={echeqsToDoActions?.echeq?.emisor_moneda}
                        idEcheq={echeqsToDoActions?.echeq?.cheque_id}
                        document={`${echeqsToDoActions?.echeq?.avalistas[0]?.aval_documento_tipo} ${echeqsToDoActions?.echeq?.avalistas[0]?.aval_documento}`}
                        avalista={echeqsToDoActions?.echeq?.avalistas[0]?.aval_razon_social}
                        domicilio={echeqsToDoActions?.echeq?.avalistas[0]?.aval_domicilio}
                        caracterAval={echeqsToDoActions?.echeq?.avalistas[0]?.aval_caracter}
                        fechaEmision={echeqsToDoActions?.echeq?.fecha_emision}
                        fechaPago={echeqsToDoActions?.echeq?.fecha_pago}
                        concepto={echeqsToDoActions?.echeq?.cheque_concepto}
                        motivoAnulacion={motiveSelect()}
                        action={echeqsToDoActions?.action}
                    />
                    <GeneralCredentialForm
                        transactionData={data}
                        action={echeckActions.updateAvalState}
                        idActivity={activity}
                        hideIndications
                    />
                </div>
            </MainContainer>
        </>
    );
};

export default ActionsAvalSummaryPage;
